import {formatMoney as themeFormatMoney} from "@shopify/theme-currency";

// Shopify can only configure the money format for the shop's base currency (USD),
// so Canadian (CAD) prices on primalharvest.ca would otherwise render as a bare "$".
// Prefix them "CA$" so they are not mistaken for US dollars. Every other currency,
// and any call that passes its own format, goes to the library untouched.
const CAD_FORMAT = "CA${{amount}}";

export function activeCurrency() {
  if (typeof window === "undefined") return null;
  return window.Shopify?.currency?.active ?? null;
}

export function formatMoney(cents, format) {
  if (format === undefined && activeCurrency() === "CAD") {
    return themeFormatMoney(cents, CAD_FORMAT);
  }
  return themeFormatMoney(cents, format);
}
